<template>
  <vonap-window
    ref="window"
    :width="'850px;'"
    title="FX Instruction"
    :visible="true"
    style="display:none"
    @cancel="close"
    @close="close"
    :modal="true"
  >
    <v-card v-if="loading" style="height: 400px">
      <v-progress-circular :indeterminate="true"></v-progress-circular>
      <h1>Loading...</h1>
    </v-card>
    <v-form ref="editForm" @submit.prevent="save" v-else>
      <v-card>
        <v-layout>
          <div
            class="blue darken-2 layout row wrap white--text mx-auto"
            style="height: 35px; padding-top: 2px;"
          >
            <v-flex d-flex xs7 style="padding-left:2px;">
              <v-flex>
                <label> Sector:</label>
              </v-flex>
              <v-flex>
                <span>{{ sector }}</span>
              </v-flex>
              <v-flex>
                <label> Instruction Date: </label>
              </v-flex>
              <v-flex>
                <kendo-datepicker
                  style="width:120px"
                  :format="'yyyy-MM-dd'"
                  :required="true"
                  v-model="instructionDate"
                  :readonly="true"
                ></kendo-datepicker>
              </v-flex>
            </v-flex>
            <v-flex d-flex xs5>
              <div class="text-xs-right" style="padding-right: 2px;">
                <kendo-button
                  v-show="instructionId != -1"
                  icon="word"
                  title="export to word"
                  @click="exportToWord"
                  type="button"
                >
                </kendo-button>
              </div>
            </v-flex>
          </div>
        </v-layout>
        <v-layout style="height:10px;"> </v-layout>
        <v-layout style="padding-left:4px; font-weight: bold;">
          <v-flex d-flex xs2 style="text-align: right; padding-right: 5px;">
            <span>{{ foreignCcy }}</span>
          </v-flex>
          <v-flex d-flex xs3>
            <span>{{ counterparty }} {{ foreignCcySectorAccountNumber }}</span>
          </v-flex>
        </v-layout>
        <v-layout style="padding-left:4px; font-weight: bold;">
          <v-flex d-flex xs2 style="text-align: right; padding-right: 5px;">
            <span>{{ baseCcy }}</span>
          </v-flex>
          <v-flex d-flex xs3>
            <span>{{ counterparty }} {{ baseCcySectorAccountNumber }}</span>
          </v-flex>
        </v-layout>

        <v-layout style="padding-left:4px;">
          <v-flex d-flex xs2 style="text-align: right; padding-right: 5px;">
            <label> Object:</label>
          </v-flex>
          <v-flex d-flex xs3>
            <input v-model="objectText" style="border-style: inset;" />
          </v-flex>
        </v-layout>
        <v-layout style="padding-left:4px;">
          <v-flex d-flex xs2 style="text-align: right; padding-right: 5px;">
            <label> Generic Text:</label>
          </v-flex>
          <v-flex d-flex xs3>
            <textarea
              type="text"
              v-model="genericText"
              style="width: 100%; height: 60px; border-style: inset;"
            ></textarea>
          </v-flex>
        </v-layout>
        <v-layout style="height:10px;"> </v-layout>

        <v-layout>
          <v-flex d-flex xs12>
            <kendo-grid
              :dataSource="gridDataSource"
              :editable="false"
              ref="grid"
              :filterable="false"
              :sortable="false"
              :pageable-always-visible="false"
              :columns="columns"
              style="height: 200px;"
            >
            </kendo-grid>
          </v-flex>
        </v-layout>

        <v-layout style="height:10px;"> </v-layout>
        <v-layout style="padding-left:4px; font-weight: bold;">
          <v-flex d-flex xs2 style="text-align: right; padding-right: 5px;">
            <label style="padding-top: 4px;"> Signator:</label>
          </v-flex>
          <v-flex d-flex xs2>
            <kendo-dropdownlist
              :data-source="signators"
              :data-text-field="'signator'"
              :data-value-field="'signatorId'"
              v-model="signatorId"
              style="width: 75px;"
            >
            </kendo-dropdownlist>
          </v-flex>
        </v-layout>
        <v-layout style="height:10px;"> </v-layout>
      </v-card>
      <v-layout>
        <v-flex d-flex xs12>
          <div class="text-xs-right">
            <v-btn color="blue primary" type="submit">Save</v-btn>
            <v-btn color="blue primary" @click="deleteInstruction" v-show="instructionId != -1"
              >Delete</v-btn
            >
          </div>
        </v-flex>
      </v-layout>
    </v-form>
  </vonap-window>
</template>
<script>
import VonapWindow from '@/components/VonapWindow'
import confirmationWindow from '@/helpers/confirmation-window'
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'
import axios from 'axios'
export default {
  async mounted() {
    this.loading = true
    const url =
      this.operationIds.length > 0
        ? '/api/heroux/Instruction/getInstructionDeals'
        : '/api/heroux/Instruction/getInstructionData'
    const params =
      this.operationIds.length > 0
        ? {clientId: this.clientId, operationIds: this.operationIds}
        : {
            clientId: this.clientId,
            instructionId: this.instructionId,
          }

    const {data} = await axios.get(url, {
      params: params,
    })

    if (this.operationIds.length > 0) {
      if (data.counterpartyId == -1) {
        notification("Doesn't have a valid Bank Counterparty", 'error')
        return
      }

      if (data.baseCcySectorAccountId == -1) {
        const message =
          "Account doesn't exist for the Currency: '" +
          data.baseCcy +
          "' Sector: '" +
          data.sector +
          "' and Counterparty: '" +
          data.counterparty
        notification(message, 'error')
        return
      }

      if (data.foreignCcySectorAccountId == -1) {
        const message =
          "Account doesn't exist for the Currency: '" +
          data.foreignCcy +
          "' Sector: '" +
          data.sector +
          "' and Counterparty: '" +
          data.counterparty
        notification(message, 'error')
        return
      }
    }

    Object.assign(this, data)
    this.loading = false
  },
  components: {
    VonapWindow,
  },
  props: {
    instructionId: {
      type: Number,
      default: -1,
    },
    modalVisible: Boolean,
    operationIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    exportToWord() {
      window.location.href = `/api/heroux/Instruction/exportInstruction?clientId=${this.clientId}
      &instructionId=${this.instructionId}&t=${this.tokenString}`
    },
    async save() {
      const isNew = this.operationIds.length > 0
      const url = isNew
        ? '/api/heroux/Instruction/createFxInstruction'
        : '/api/heroux/Instruction/updateInstruction'
      const params = isNew
        ? {
            operationIds: this.operationIds,
            instructionDate: this.instructionDate,
            instructionId: this.instructionId,
            sectorId: this.sectorId,
            counterpartyId: this.counterpartyId,
            foreignCcySectorAccountId: this.foreignCcySectorAccountId,
            baseCcySectorAccountId: this.baseCcySectorAccountId,
            signatorId: this.signatorId,
            objectText: this.objectText,
            genericText: this.genericText,
          }
        : {
            instructionId: this.instructionId,
            signatorId: this.signatorId,
            instructionDate: this.instructionDate,
            sectorId: this.sectorId,
            counterpartyId: this.counterpartyId,
            foreignCcySectorAccountId: this.foreignCcySectorAccountId,
            baseCcySectorAccountId: this.baseCcySectorAccountId,
            objectText: this.objectText,
            genericText: this.genericText,
          }

      const {data} = isNew ? await axios.post(url, params) : await axios.put(url, params)

      if (isNew) {
        this.$emit('createSuccess', data.instructionId)
      }
    },
    deleteInstruction() {
      const vm = this
      confirmationWindow.openConfirmationWindow(
        'Instruction',
        'Are you sure you want to delete the selected Instruction?',
        async () => {
          await axios.delete('/api/heroux/Instruction/destroyInstruction', {
            params: {instructionId: vm.instructionId},
          })
          vm.$emit('close')
        },
      )
    },
  },
  data() {
    return {
      loading: true,
      deals: [],
      signators: [],
      signatorId: '',
      instructionDate: null,
      sectorId: -1,
      sector: '',
      counterpartyId: -1,
      counterparty: '',
      foreignCcy: 'N/A',
      baseCcy: 'N/A',
      foreignCcySectorAccountId: -1,
      foreignCcySectorAccountNumber: '',
      baseCcySectorAccountId: -1,
      baseCcySectorAccountNumber: '',
      objectText: '',
      genericText: '',
      columns: [
        {
          field: 'reference',
          title: 'Reference',
          width: '100',
          attributes: {style: 'text-align: left;'},
        },
        {field: 'dealCode', title: 'Trade Id', width: '100'},
        {field: 'buySell', title: 'Buy Sell', width: '80'},
        {
          field: 'foreignAmount',
          title: 'Amount',
          format: '{0:N2}',
          attributes: {style: 'text-align: right;'},
        },
        {field: 'foreignCcy', title: 'Ccy', width: '80'},
        {
          field: 'hedgeRate',
          title: 'Rate',
          format: '{0:N4}',
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'startDate',
          title: 'Start Date',
          width: '100',
          format: '{0:yyyy-MM-dd}',
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'maturityDate',
          title: 'Maturity Date',
          width: '100',
          format: '{0:yyyy-MM-dd}',
          attributes: {style: 'text-align: right;'},
        },
      ],
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    gridDataSource() {
      return new kendo.data.DataSource({
        data: this.deals,
        schema: {
          model: {
            id: 'dealId',
            fields: {
              dealId: {type: 'number'},
              operationId: {type: 'number'},
              dealCode: {type: 'string'},
              reference: {type: 'string'},
              buySell: {type: 'string'},
              foreignAmount: {type: 'number'},
              foreignCcy: {type: 'string'},
              hedgeRate: {type: 'number'},
              startDate: {type: 'date'},
              maturityDate: {type: 'date'},
              baseCcy: {type: 'string'},
              ccyPairId: {type: 'number'},
            },
          },
        },
      })
    },
  },
}
</script>
